import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  Carousel: {
    height: '90%',
    alignItems: 'center',
  },
  CarouselTitle: {
    maxWidth: '85%',
    marginBottom: 40,
  },
  Arrow: {
    width: 26,
    height: 50,
    [theme.breakpoints.up('md')]: {
      width: 13,
      height: 26,
    },
  },
  arrowLeft: {
    order: 2,
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      order: 1,
    },
  },
  CardsSlider: {
    order: 2,
  },
  arrowRight: {
    order: 4,
    display: 'flex',
    justifyContent: 'center',
  },
  Slider: {
    '& div': {
      marginRight: 0,
    },
  },
}));
